import React, { useState, useEffect, useContext } from 'react';
import LayoutContext from 'components/contexts/LayoutContext.jsx';
import OptionRowFloat from 'components/layout_and_quote_builder/options/OptionRowFloat.jsx'
import LoadFromLocalStorage from 'components/layout_and_quote_builder/options/LoadFromLocalStorage.jsx'
import styles from 'components/layout_and_quote_builder/_style.module.scss';
import Constants from 'components/layout_and_quote_builder/Constants.jsx'
import MyEventListener from 'components/common/MyEventListener.jsx'

// Layout dimensions to hide from the dropdown
const HIDDEN_LAYOUT_DIMENSIONS = [
  "2A0 1189mm X 1682mm",
  "4A0 1682mm X 2378mm",
];

// For "Other sizes" group, only show these dimensions
const ALLOWED_OTHER_SIZES = [
  "700mm X 1000mm",
];

const ChooseLayoutDimensions = ({ index, title, item, hideMargins, hideCustom, publicSetter, defaultValues, smallerSubSetOf, disableMargins}) => {
  const myLayoutContext = useContext(LayoutContext);
  const [isEditMode, setIsEditMode] = useState(false);

  // Get initial primary layout dimension ID
  const getInitialPrimaryLayoutDimensionId = () => {
    if (defaultValues["layout_dimension_ids"]) {
      const ids = Array.isArray(defaultValues["layout_dimension_ids"])
        ? defaultValues["layout_dimension_ids"]
        : [defaultValues["layout_dimension_ids"]];
      return ids[0] || 21;
    }
    if (defaultValues["layout_dimension_id"]) {
      return defaultValues["layout_dimension_id"];
    }
    if (myLayoutContext.layoutOptions.layout_dimension_ids) {
      return myLayoutContext.layoutOptions.layout_dimension_ids[0] || 21;
    }
    if (myLayoutContext.layoutOptions.layout_dimension_id) {
      return myLayoutContext.layoutOptions.layout_dimension_id;
    }
    return 21; // Default fallback
  };

  // Get initial alternative layout dimension ID
  const getInitialAlternativeLayoutDimensionId = () => {
    if (defaultValues["layout_dimension_ids"]) {
      const ids = Array.isArray(defaultValues["layout_dimension_ids"])
        ? defaultValues["layout_dimension_ids"]
        : [defaultValues["layout_dimension_ids"]];
      return ids[1] || '';
    }
    if (myLayoutContext.layoutOptions.layout_dimension_ids) {
      return myLayoutContext.layoutOptions.layout_dimension_ids[1] || '';
    }
    return ''; // No alternative by default
  };

  const [primaryLayoutDimensionId, setPrimaryLayoutDimensionId] = useState(getInitialPrimaryLayoutDimensionId());
  const [alternativeLayoutDimensionId, setAlternativeLayoutDimensionId] = useState(getInitialAlternativeLayoutDimensionId());

  const [layout_dimension_width, set_layout_dimension_width] = useState( defaultValues["layout_dimension_width"] || myLayoutContext.layoutOptions.layout_dimension_width);
  const [layout_dimension_height, set_layout_dimension_height] = useState(defaultValues["layout_dimension_height"] || myLayoutContext.layoutOptions.layout_dimension_height);

  const [layout_dimension_top_margin_diecutting, set_layout_dimension_top_margin_diecutting]       = useState(defaultValues["layout_dimension_top_margin"]    || myLayoutContext.layoutOptions.layout_dimension_top_margin);
  const [layout_dimension_side_margin_diecutting, set_layout_dimension_side_margin_diecutting]     = useState(defaultValues["layout_dimension_side_margin"]   || myLayoutContext.layoutOptions.layout_dimension_side_margin);
  const [layout_dimension_bottom_margin_diecutting, set_layout_dimension_bottom_margin_diecutting] = useState(defaultValues["layout_dimension_bottom_margin"] || myLayoutContext.layoutOptions.layout_dimension_bottom_margin);

  const [layout_dimension_top_margin_printing, set_layout_dimension_top_margin_printing]       = useState(defaultValues["layout_dimension_top_margin"]    || myLayoutContext.layoutOptions.layout_dimension_top_margin);
  const [layout_dimension_side_margin_printing, set_layout_dimension_side_margin_printing]     = useState(defaultValues["layout_dimension_side_margin"]   || myLayoutContext.layoutOptions.layout_dimension_side_margin);
  const [layout_dimension_bottom_margin_printing, set_layout_dimension_bottom_margin_printing] = useState(defaultValues["layout_dimension_bottom_margin"] || myLayoutContext.layoutOptions.layout_dimension_bottom_margin);

  const [layout_dimension_filtering_enabled, set_layout_dimension_filtering_enabled] = useState( false );

  // Temporary display state for immediate UI feedback
  const [temp_top_margin_diecutting, set_temp_top_margin_diecutting] = useState(layout_dimension_top_margin_diecutting);
  const [temp_side_margin_diecutting, set_temp_side_margin_diecutting] = useState(layout_dimension_side_margin_diecutting);
  const [temp_bottom_margin_diecutting, set_temp_bottom_margin_diecutting] = useState(layout_dimension_bottom_margin_diecutting);
  const [temp_top_margin_printing, set_temp_top_margin_printing] = useState(layout_dimension_top_margin_printing);
  const [temp_side_margin_printing, set_temp_side_margin_printing] = useState(layout_dimension_side_margin_printing);
  const [temp_bottom_margin_printing, set_temp_bottom_margin_printing] = useState(layout_dimension_bottom_margin_printing);

  const getSmallerSubSetOfValues = () => {
    if(smallerSubSetOf == undefined) { return [ ] }
    const res = [];
    var width = 0
    var height = 0

    for (let [key, values] of Object.entries(myLayoutContext.dimensionGroups)) {
      for(let i=0; i < values.length; i++) {

        if(values[i].id == smallerSubSetOf) {
          width = values[i].width
          height = values[i].height
        }
      }
    }

    return [width, height]
  }

  const correct = (value) => {
    var close = 0.05;
    if( Math.abs( Math.ceil(value) - value ) < close ) { return true }
    if( Math.abs( Math.floor(value) - value ) < close ) { return true }

    return false
  }

  const getSmallerSubSetOfIds = () => {
    if(smallerSubSetOf == undefined) {
      return []
    }

    let smallerSubSetOfValues = getSmallerSubSetOfValues()
    const w = smallerSubSetOfValues[0];
    const h = smallerSubSetOfValues[1];
    var res = []

    for (let [key, values] of Object.entries(myLayoutContext.dimensionGroups)) {
      for(let i=0; i < values.length; i++) {
        let value = values[i];
        let w_part = w / value.width;
        let h_part = h / value.height;
        if( w_part > 0.99 && h_part > 0.99 && correct(w_part) && correct(h_part) ) {
          res.push(value.id)
        }
      }
    }
    return res
  }

  // Check if a layout dimension should be shown based on filtering rules
  const shouldShowLayoutDimension = (value, groupName) => {
    // Hide specific dimensions by description
    if (HIDDEN_LAYOUT_DIMENSIONS.includes(value.description)) {
      return false;
    }

    // For "Other sizes" group, only show allowed dimensions
    if (groupName === "Other sizes") {
      return ALLOWED_OTHER_SIZES.includes(value.description);
    }

    return true;
  };

  // Get all layout dimension options grouped by groupName
  const getGroupedLayoutDimensionOptions = () => {
    let groupedOptions = {};
    let smallerSubSetOfListIds = getSmallerSubSetOfIds();

    for (let [groupName, values] of Object.entries(myLayoutContext.dimensionGroups)) {
      let sortedValues = [...values].sort((a, b) => a.description.localeCompare(b.description));
      if (groupName === "Other sizes") {
        sortedValues = sortedValues.reverse();
      }

      sortedValues.forEach((value) => {
        // Apply visibility filtering
        if (!shouldShowLayoutDimension(value, groupName)) {
          return;
        }

        if (smallerSubSetOfListIds.length > 0) {
          if (smallerSubSetOfListIds.includes(value.id)) {
            if (!groupedOptions[groupName]) {
              groupedOptions[groupName] = [];
            }
            groupedOptions[groupName].push({ ...value, groupName });
          }
        } else {
          if (!groupedOptions[groupName]) {
            groupedOptions[groupName] = [];
          }
          groupedOptions[groupName].push({ ...value, groupName });
        }
      });
    }

    return groupedOptions;
  };

  // Compute layout_dimension_ids from primary and alternative for backwards compatibility
  const getLayoutDimensionIds = () => {
    const ids = [parseInt(primaryLayoutDimensionId, 10)];
    if (alternativeLayoutDimensionId) {
      ids.push(parseInt(alternativeLayoutDimensionId, 10));
    }
    return ids;
  };

  const formatValue = (value) => {
    let toFormat = parseFloat(value);
    let formatted = (Number.isNaN(toFormat) ? 0 : toFormat).toFixed(layout_dimension_unit == 'in' ? 4 : 2);
    return formatted
  }

  // Simple onChange handlers that update temp state immediately
  const handleTopMarginDiecutting = (value) => set_temp_top_margin_diecutting(value);
  const handleSideMarginDiecutting = (value) => set_temp_side_margin_diecutting(value);
  const handleBottomMarginDiecutting = (value) => set_temp_bottom_margin_diecutting(value);
  const handleTopMarginPrinting = (value) => set_temp_top_margin_printing(value);
  const handleSideMarginPrinting = (value) => set_temp_side_margin_printing(value);
  const handleBottomMarginPrinting = (value) => set_temp_bottom_margin_printing(value);

  // Edit/Save handler
  const handleEditSave = (e) => {
    e.preventDefault();
    if (isEditMode) {
      // Save mode: Update all permanent states
      set_layout_dimension_top_margin_diecutting(temp_top_margin_diecutting);
      set_layout_dimension_side_margin_diecutting(temp_side_margin_diecutting);
      set_layout_dimension_bottom_margin_diecutting(temp_bottom_margin_diecutting);
      set_layout_dimension_top_margin_printing(temp_top_margin_printing);
      set_layout_dimension_side_margin_printing(temp_side_margin_printing);
      set_layout_dimension_bottom_margin_printing(temp_bottom_margin_printing);
      setIsEditMode(false);
    } else {
      // Edit mode: Enable fields
      setIsEditMode(true);
    }
  };

  const onSolutionSet = (msg) => {
    if(msg.detail.index != index) { return }

    let diecutting_result = msg.detail.solution.diecutting_result
    let printing_result = diecutting_result.printing_result

    console.log( "-------------onSolutionSet------------------------" );

    // Exit edit mode since backend is providing new values
    setIsEditMode(false);

    const topDiecutting = formatValue(diecutting_result.user_margin_top);
    const sideDiecutting = formatValue(diecutting_result.user_margin_side);
    const bottomDiecutting = formatValue(diecutting_result.user_margin_bottom);
    const topPrinting = formatValue(printing_result.margins.user_margin_top);
    const sidePrinting = formatValue(printing_result.margins.user_margin_side);
    const bottomPrinting = formatValue(printing_result.margins.user_margin_bottom);

    // Update both permanent and temp states
    set_layout_dimension_top_margin_diecutting(topDiecutting);
    set_layout_dimension_side_margin_diecutting(sideDiecutting);
    set_layout_dimension_bottom_margin_diecutting(bottomDiecutting);
    set_layout_dimension_top_margin_printing(topPrinting);
    set_layout_dimension_side_margin_printing(sidePrinting);
    set_layout_dimension_bottom_margin_printing(bottomPrinting);

    set_temp_top_margin_diecutting(topDiecutting);
    set_temp_side_margin_diecutting(sideDiecutting);
    set_temp_bottom_margin_diecutting(bottomDiecutting);
    set_temp_top_margin_printing(topPrinting);
    set_temp_side_margin_printing(sidePrinting);
    set_temp_bottom_margin_printing(bottomPrinting);
  }

  const layout_dimension_unit = myLayoutContext.layoutOptions.layout_dimension_unit;
  const getPublicData = () => {
    return {
      layout_dimension_ids: getLayoutDimensionIds(),
      layout_dimension_unit,
      layout_dimension_top_margin_diecutting,
      layout_dimension_side_margin_diecutting,
      layout_dimension_bottom_margin_diecutting,
      layout_dimension_top_margin_printing,
      layout_dimension_side_margin_printing,
      layout_dimension_bottom_margin_printing,
      layout_dimension_filtering_enabled,
    }
  }

  const setPublicData = () => { publicSetter( () => getPublicData() ) }
  const dimensionIdsSetter = (value) => {
    if (Array.isArray(value)) {
      const ids = value.map(v => parseInt(v, 10)).filter(v => v > 0);
      if (ids.length > 0) {
        setPrimaryLayoutDimensionId(ids[0]);
      }
      if (ids.length > 1) {
        setAlternativeLayoutDimensionId(ids[1]);
      } else {
        setAlternativeLayoutDimensionId('');
      }
    } else if (value > 0) {
      setPrimaryLayoutDimensionId(parseInt(value, 10));
      setAlternativeLayoutDimensionId('');
    }
  }

  // Determine if fields should be disabled
  const fieldsDisabled = !isEditMode || disableMargins;

  useEffect(() => LoadFromLocalStorage(item, 'layout_dimension_ids', dimensionIdsSetter), []);

  if(publicSetter != undefined) {
    useEffect( setPublicData, [
      primaryLayoutDimensionId,
      alternativeLayoutDimensionId,
      layout_dimension_unit,
      layout_dimension_top_margin_diecutting,
      layout_dimension_side_margin_diecutting,
      layout_dimension_bottom_margin_diecutting,
      layout_dimension_top_margin_printing,
      layout_dimension_side_margin_printing,
      layout_dimension_bottom_margin_printing,
      layout_dimension_filtering_enabled,
    ])
  }

  useEffect( () => {
    emitEvent(Constants.layout_dimension_changed, {
      index: index,
    })
  }, [primaryLayoutDimensionId, alternativeLayoutDimensionId])

  // Sync temporary state with permanent state when permanent state changes externally
  useEffect(() => { set_temp_top_margin_diecutting(layout_dimension_top_margin_diecutting); }, [layout_dimension_top_margin_diecutting]);
  useEffect(() => { set_temp_side_margin_diecutting(layout_dimension_side_margin_diecutting); }, [layout_dimension_side_margin_diecutting]);
  useEffect(() => { set_temp_bottom_margin_diecutting(layout_dimension_bottom_margin_diecutting); }, [layout_dimension_bottom_margin_diecutting]);
  useEffect(() => { set_temp_top_margin_printing(layout_dimension_top_margin_printing); }, [layout_dimension_top_margin_printing]);
  useEffect(() => { set_temp_side_margin_printing(layout_dimension_side_margin_printing); }, [layout_dimension_side_margin_printing]);
  useEffect(() => { set_temp_bottom_margin_printing(layout_dimension_bottom_margin_printing); }, [layout_dimension_bottom_margin_printing]);

  MyEventListener( [{
    key: 'quote_builder.solution_set',
    callback: onSolutionSet
  }] )

  // Render a standard select dropdown with optgroups
  const renderDimensionSelect = (selectedValue, onChange, label, allowEmpty = false) => {
    const groupedOptions = getGroupedLayoutDimensionOptions();

    return (
      <div style={{display: 'flex', alignItems: 'center', gap: '10px', justifyContent: 'flex-end'}}>
        <span style={{whiteSpace: 'nowrap'}}>{label}</span>
        <select
          className="form-control"
          value={selectedValue}
          onChange={(e) => onChange(e.target.value)}
          disabled={window.user_quote_finalised}
          style={{
            cursor: window.user_quote_finalised ? 'not-allowed' : 'pointer',
            backgroundColor: window.user_quote_finalised ? '#e9ecef' : 'white',
            width: 'auto',
            minWidth: '200px',
          }}
        >
          {allowEmpty && <option value="">-- None --</option>}
          {Object.entries(groupedOptions).map(([groupName, options]) => (
            <optgroup key={groupName} label={groupName}>
              {options.map((option) => (
                <option key={option.id} value={option.id}>
                  {option.description}
                </option>
              ))}
            </optgroup>
          ))}
        </select>
      </div>
    );
  }

  return (<>
  <div >

    <input type="hidden" value={layout_dimension_unit} name="layout_dimension_unit"/>
    <table className="table  table-bordered">
      <tbody>
        <tr>
          <td colSpan="3" style={{textAlign: 'right'}}>
            <div style={{display: 'flex', justifyContent: 'flex-end', gap: '20px'}}>
              {renderDimensionSelect(
                primaryLayoutDimensionId,
                setPrimaryLayoutDimensionId,
                title != undefined ? title : window.wording_layouts_choose_dimensions
              )}
              {renderDimensionSelect(
                alternativeLayoutDimensionId,
                setAlternativeLayoutDimensionId,
                t('quote_builder.alternative_material_dimension'),
                true
              )}
            </div>
          </td>
        </tr>

        <tr>

          <td>
            { !hideMargins &&
            <OptionRowFloat description={t('layouts.top_margin_diecutting')}
              item={item}
              name="layout_dimension_top_margin_diecutting"
              value={temp_top_margin_diecutting}
              unit={myLayoutContext.unit}
              onChange={handleTopMarginDiecutting}
              disabled={fieldsDisabled}
            /> }
          </td>
          <td>
            { !hideMargins && <OptionRowFloat description={t('layouts.side_margin_diecutting')}
              item={item}
              name="layout_dimension_side_margin_diecutting"
              value={temp_side_margin_diecutting}
              unit={myLayoutContext.unit}
              onChange={handleSideMarginDiecutting}
              disabled={fieldsDisabled}
            /> }
          </td>

          <td>
            { !hideMargins && <OptionRowFloat description={t('layouts.bottom_margin_diecutting')}
              item={item}
              name="layout_dimension_bottom_margin_diecutting"
              value={temp_bottom_margin_diecutting}
              unit={myLayoutContext.unit}
              onChange={handleBottomMarginDiecutting}
              disabled={fieldsDisabled}
            /> }
          </td>

        </tr>

        <tr>
          <td>
            { !hideMargins &&
            <OptionRowFloat description={t('layouts.top_margin_printing')}
              item={item}
              name="layout_dimension_top_margin_printing"
              value={temp_top_margin_printing}
              unit={myLayoutContext.unit}
              onChange={handleTopMarginPrinting}
              disabled={fieldsDisabled}
            /> }
          </td>
          <td>
            { !hideMargins && <OptionRowFloat description={t('layouts.side_margin_printing')}
              item={item}
              name="layout_dimension_side_margin_printing"
              value={temp_side_margin_printing}
              unit={myLayoutContext.unit}
              onChange={handleSideMarginPrinting}
              disabled={fieldsDisabled}
            /> }
          </td>

          <td>
            { !hideMargins && <OptionRowFloat description={t('layouts.bottom_margin_printing')}
              item={item}
              name="layout_dimension_bottom_margin_printing"
              value={temp_bottom_margin_printing}
              unit={myLayoutContext.unit}
              onChange={handleBottomMarginPrinting}
              disabled={fieldsDisabled}
            /> }
          </td>

        </tr>

        { !hideMargins && (
          <tr>
            <td colSpan="3" style={{paddingTop: '0px', paddingBottom: '20px', textAlign: 'right'}}>
              <a
                href="#"
                onClick={handleEditSave}
                style={{
                  pointerEvents: disableMargins ? 'none' : 'auto',
                  opacity: disableMargins ? 0.5 : 1,
                  cursor: disableMargins ? 'not-allowed' : 'pointer',
                  textDecoration: 'none',
                }}
              >
                {!isEditMode && <>  <i className="fa fa-pencil-square-o" aria-hidden="true"></i> Edit margins </>}
                {isEditMode && <> <i className="fa fa-floppy-o" aria-hidden="true"></i> Save margins </>}
              </a>
            </td>
          </tr>
        )}

        <tr>
          <td colSpan="3" style={{paddingTop: '10px', paddingBottom: '10px'}}>
            <label style={{display: 'flex', alignItems: 'center', cursor: 'pointer'}}>
              <input
                type="checkbox"
                checked={layout_dimension_filtering_enabled}
                onChange={(e) => set_layout_dimension_filtering_enabled(e.target.checked)}
                style={{marginRight: '8px'}}
              />
              <span>Cözüm Filtreleme</span>
            </label>
          </td>
        </tr>

      </tbody>
    </table>

    </div>
    <div style={{'clear': 'both' }} ></div>
  </>)
}

export default ChooseLayoutDimensions;
